import { userApi } from '@/api/userManagement';

const state = {
  admins: []
}

const mutations = {
  SET_ADMINS(state, admins) {
    state.admins = admins
  },
  ADD_ADMIN(state, admin) {
    state.admins.push(admin)
  },
  UPDATE_ADMIN(state, updatedAdmin) {
    const index = state.admins.findIndex(admin => admin.id === updatedAdmin.id)
    if (index !== -1) {
      state.admins.splice(index, 1, updatedAdmin)
    }
  },
  REMOVE_ADMIN(state, adminId) {
    state.admins = state.admins.filter(admin => admin.id !== adminId)
  }
}

const actions = {
  async fetchAdmins({ commit }) {
    try {
      const admins = await userApi.getAllUsers();
      commit('SET_ADMINS', admins);
    } catch (error) {
      console.error('Error fetching admins:', error);
    }
  },
  async addAdmin({ commit }, admin) {
    try {
      const newAdmin = await userApi.createUser(admin);
      commit('ADD_ADMIN', newAdmin);
    } catch (error) {
      console.error('Error adding admin:', error);
    }
  },
  async updateAdmin({ commit }, admin) {
    try {
      const updatedAdmin = await userApi.updateUser(admin.id, admin);
      commit('UPDATE_ADMIN', updatedAdmin);
    } catch (error) {
      console.error('Error updating admin:', error);
    }
  },
  async removeAdmin({ commit }, adminId) {
    try {
      await userApi.deleteUser(adminId);
      commit('REMOVE_ADMIN', adminId);
    } catch (error) {
      console.error('Error removing admin:', error);
    }
  }
}

const getters = {
  getAdmins: state => state.admins
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

